import deepCopy from 'shared/utils/object/deepCopy'
import {
  ArrayFieldValue,
  GroupedFieldValues,
  Operator
} from '../../FilterFields/types'

export function applySelectAndLinkValuesToGroupedFieldValues(
  groupedFieldValues: GroupedFieldValues,
  targetGroup: string,
  targetField: string,
  values: ArrayFieldValue
): GroupedFieldValues {
  const result = deepCopy(groupedFieldValues)
  if (!result[targetGroup]) {
    result[targetGroup] = {}
  }
  const existing = result[targetGroup][targetField]
  result[targetGroup][targetField] = {
    ...existing,
    operator: (existing?.operator as Operator) ?? 'in',
    type: existing?.type ?? 'RELATION',
    value: values
  }
  return result
}
